import { css } from '@emotion/react';

import * as React from 'react';

import { Grid, InlineNotification } from '@coursera/cds-core';

import { useProgrammingProctoringConfigurationContext } from 'bundles/author-assignment-grading/components/programming/context/ProgrammingProctoringConfigurationContext';
import {
  doesAttemptSummaryHaveSubmissionLimit,
  doesAttemptSummaryHaveTimeLimit,
} from 'bundles/programming/utils/timed';

import _t from 'i18n!nls/author-assignment-grading';

const styles = {
  marginTop: css`
    margin-top: 24px;
  `,
};

const ProgrammingIseChangeNotification = () => {
  const { programmingIseContextState, attemptSummary } = useProgrammingProctoringConfigurationContext();
  const hasSubmissionLimit = attemptSummary && doesAttemptSummaryHaveSubmissionLimit(attemptSummary);
  const hasTimeLimit = attemptSummary && doesAttemptSummaryHaveTimeLimit(attemptSummary);

  const { allowedDurationSeconds, allowedSubmissions } = programmingIseContextState;

  const renderPotentialResetWarningNotification = () => {
    const allowedDurationMinutes = allowedDurationSeconds ? allowedDurationSeconds / 60 : 0;
    if (hasTimeLimit && hasSubmissionLimit) {
      return _t(
        'When the learner starts their assignment again, they will have #{allowedDurationMinutes} minutes for #{allowedSubmissions} more submissions. To avoid making this change, reload the page without saving.',
        {
          allowedSubmissions,
          allowedDurationMinutes,
        }
      );
    } else if (hasTimeLimit) {
      return _t(
        'When the learner starts their assignment again, they will have #{allowedDurationMinutes} minutes. To avoid making this change, reload the page without saving.',
        {
          allowedDurationMinutes,
        }
      );
    } else if (hasSubmissionLimit) {
      return _t(
        'The learner will have #{allowedSubmissions} more submissions. To avoid making this change, reload the page without saving.',
        {
          allowedSubmissions,
        }
      );
    } else {
      // We don't expect this to ever show up, but if there's a bug, it might. Tell the user something useful.
      return _t(
        'Unsupported item configuration. Please make sure you are using a time limit and/or a submission limit.'
      );
    }
  };

  return (
    <Grid item xs={12} css={styles.marginTop}>
      <InlineNotification severity="warning" title={_t('Potential reset')}>
        {renderPotentialResetWarningNotification()}
      </InlineNotification>
    </Grid>
  );
};

export default ProgrammingIseChangeNotification;
